import React from 'react'

const styles = {
    display: 'flex'
}

const Row = (props) => {
    const { children, ...rest } = props
    return(
        <div style={styles} {...rest}>
            {children}
        </div>
    )
}

export default Row
